<div class="container">
  <div class="change-password-container">
    <div class="row row-0" style="margin-left: 10px; margin-right: 10px;">

      <div class="col-12 text-center">
        <label class="label-sub-header">{{ $t('message.header_sub_change_password') }}</label>
        <hr class="hr-line-100">
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-12 text-center">
            <label class="sub-title-style">{{ $t('message.label_msg_enter_new_password') }}</label>
          </div>

          <div class="col-12">
            <div class="mx-auto" style="max-width: 500px;">
              <label v-html="$t('message.label_password_hint')" class="small"></label>
              <b-form-group class="form-group">
                <label class="label-sm">{{ $t('message.label_new_password') }}</label>
                <b-form-input type="password" id="id-new-password" class="w-100" v-model="newPassword" size="sm" />
              </b-form-group>
            </div>
          </div>

          <div class="col-12">
            <b-form-group class="form-group">
              <div class="mx-auto" style="max-width: 500px;">
                <label class="label-sm">{{ $t('message.label_new_password_confirm') }}</label>
                <b-form-input type="password" id="id-confirm-password" size="sm" v-model="newPasswordConfirm"
                  @paste.prevent />
              </div>
            </b-form-group>
          </div>

          <div class="col-12 text-center">
            <div class="button-change-container mb-4">
              <b-button variant="outline-primary" v-on:click="backToPrevious">
                {{ $t('message.common_button_back') }}
              </b-button>

              <b-button :disabled="!isManadatoryFilled" variant="primary" class="button-change-blank-style"
                v-on:click="executeChangePassword">
                {{ $t("message.button_change_password") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <processing-view :processing="processing"></processing-view>
    </div>
  </div>
</div>